import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import type { IDocuments } from "interfaces/documents";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  {
    prefix: "SHOW_DOCUMENT_",
  }
);

export interface ShowDocumentState {
  data: IDocuments | null;
  loading: boolean;
  error: string | null;
}

export interface ShowDocumentRequestAction {
  id: number;
  error: string | null;
  onSuccess?: (data: IDocuments) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: IDocuments;
}

interface FailureAction {
  error: string;
}

const INITIAL_STATE: ShowDocumentState = {
  data: null,
  loading: false,
  error: null,
};

const _request = (state: ShowDocumentState) =>
  update(state, { loading: { $set: true }, error: { $set: null } });

const _success = (state: ShowDocumentState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const _failure = (state: ShowDocumentState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const _reset = () => INITIAL_STATE;

export const showDocument = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: _request,
  [Types.SUCCESS]: _success,
  [Types.FAILURE]: _failure,
  [Types.RESET]: _reset,
});

export const ShowDocumentTypes = Types;
export const ShowDocumentActions = Creators;
